/**
 * hover-image.js
 * Loads the product card's second (hover) image on first interaction only.
 * Pairs with snippets/product-card-hover-image.liquid.
 *
 * Delegated listeners on document; pointerenter does not bubble, so
 * capture phase is used. Each card is promoted at most once.
 *
 * Vignovic Agency - Sock Candy Phase 1 (EO run SC-P1)
 */
(function () {
  'use strict';

  function activate(card) {
    if (card.dataset.hoverLoaded) return;
    card.dataset.hoverLoaded = 'true';
    var img = card.querySelector('.js-hover-image');
    if (!img) return;
    img.addEventListener('error', function () {
      img.style.display = 'none';
    }, { once: true });
    if (window.lazySizes) {
      img.classList.add('lazyload');
    } else if (img.dataset.fallbackSrc) {
      img.src = img.dataset.fallbackSrc;
    }
  }

  function onInteract(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var card = target.closest('.product-card');
    if (card) activate(card);
  }

    // A failed image anywhere inside a product card renders the browser's
  // broken image glyph, which reads as a broken store. Error events do not
  // bubble, so this listens in the capture phase at document level and
  // catches every image regardless of which snippet produced it.
  document.addEventListener('error', function (event) {
    var el = event.target;
    if (!el || el.tagName !== 'IMG') return;
    if (!el.closest || !el.closest('.product-card')) return;
    if (el.dataset.vgnHidden) return;
    el.dataset.vgnHidden = '1';
    el.style.visibility = 'hidden';
  }, true);
  // Error events do not bubble, so this listens in the capture phase at
  // document level and catches every image inside a product card regardless
  // of which snippet produced it or whether the card has been interacted with.
  document.addEventListener('error', function (event) {
    var el = event.target;
    if (!el || el.tagName !== 'IMG') return;
    if (!el.closest || !el.closest('.product-card')) return;
    if (el.dataset.vgnHidden) return;
    el.dataset.vgnHidden = '1';
    el.style.visibility = 'hidden';
  }, true);
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, onInteract, { passive: true, capture: true });
  });
})();
